(() => {
  const start = () => {
  if (window.ScaleShowroomCollector) return;
  const host = document.querySelector('[data-ss-os]');
  if (!host) return;
  const labels = JSON.parse(host.querySelector('[data-ss-labels]').textContent);
  const root = host.dataset.root || '/';
  const origin = new URL(host.dataset.origin || document.baseURI).origin;
  const key = 'scale-showroom.collector.v1';
  const limits = {saved: 24, compare: 3, recent: 8};
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  const compactRecord = model => ({handle: model.handle, title: String(model.title || model.handle).slice(0,300)});
  const normalise = value => Object.fromEntries(Object.entries(limits).map(([kind, limit]) => {
    const seen = new Set();
    const entries = Array.isArray(value?.[kind]) ? value[kind] : [];
    return [kind, entries.filter(item => validHandle(item?.handle) && !seen.has(item.handle) && seen.add(item.handle)).slice(0,limit).map(compactRecord)];
  }));
  let persistent = true;
  let state;
  try { state = normalise(JSON.parse(localStorage.getItem(key) || '{}')); } catch (_) { state = normalise({}); persistent = false; }
  const dialog = host.querySelector('dialog');
  const panel = host.querySelector('[data-ss-panel]');
  const cache = new Map();
  let mode = 'saved', generation = 0, previousFocus, previousOverflow, toastTimer, deskAddPending = false;
  const write = () => {
    try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) { persistent = false; }
    host.querySelector('[data-ss-storage-note]').textContent = persistent ? host.querySelector('[data-ss-storage-note]').dataset.defaultText : labels.session_note;
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const arrow = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('viewBox','0 0 24 24'); svg.setAttribute('width','18'); svg.setAttribute('height','18');
    svg.setAttribute('fill','none'); svg.setAttribute('stroke','currentColor'); svg.setAttribute('stroke-width','1.5'); svg.setAttribute('aria-hidden','true');
    const path = document.createElementNS('http://www.w3.org/2000/svg','path'); path.setAttribute('d','M5 19 19 5M5 5h14v14'); svg.append(path); return svg;
  };
  const productURL = handle => root + 'products/' + encodeURIComponent(handle);
  const safeModel = raw => {
    if (!validHandle(raw?.handle)) throw new Error(labels.load_error);
    const url = new URL(raw.url || productURL(raw.handle), origin);
    if (url.origin !== origin || !url.pathname.includes('/products/')) throw new Error(labels.load_error);
    const model = {...raw, title: String(raw.title || raw.handle), url: url.pathname + url.search};
    const tags = Array.isArray(raw.tags) ? raw.tags.filter(tag => typeof tag === 'string') : [];
    model.scale = tags.find(tag => /^1:\d{1,4} Scale$/i.test(tag))?.replace(/ Scale$/i,'') || model.title.match(/\b1[:/]\d{1,4}\b/)?.[0].replace('/',':') || '';
    model.material = tags.filter(tag => /^(Resin|Diecast Metal|Plastic|Composite)$/i.test(tag)).join(' / ');
    const description = new DOMParser().parseFromString(String(raw.description || ''), 'text/html');
    const facts = [...description.querySelectorAll('li')].map(li => li.textContent.trim());
    model.material ||= facts.find(text => /^made of\b/i.test(text) && text.length < 160) || '';
    model.dimensions = facts.find(text => /^(approx(?:imate)?\.?\s+)?dimensions\b/i.test(text) && text.length < 200) || '';
    const length = model.dimensions.match(/\bL\s*[-:]\s*(\d+(?:\.\d+)?)/i);
    const units = [...model.dimensions.matchAll(/\b(inches|inch|cm|centimeters|centimetres)\b/gi)].map(match => /^in/i.test(match[1]) ? 'in' : 'cm');
    model.lengthCm = length && units.length && new Set(units).size === 1 ? Number(length[1]) * (units[0] === 'in' ? 2.54 : 1) : null;
    model.openings = facts.filter(text => /^(has\s+)?opening\b/i.test(text) && text.length < 180).join(' · ');
    delete model.description;
    if (raw.image) { const image = new URL(raw.image, origin); model.image = image.protocol === 'https:' ? image.href : ''; }
    return model;
  };
  const readModel = target => {
    try { return safeModel(JSON.parse(target.closest('[data-ss-model]').dataset.ssModel)); } catch (_) { return null; }
  };
  const toast = message => {
    const box = host.querySelector('[data-ss-toast]');
    clearTimeout(toastTimer); (dialog.open ? dialog : host).append(box); box.textContent = message; box.hidden = false;
    toastTimer = setTimeout(() => { box.hidden = true; }, 3500);
  };
  const has = (kind, handle) => state[kind].some(item => item.handle === handle);
  const syncButtons = () => {
    host.querySelector('.ss-compare-launcher').hidden = state.compare.length < 2;
    document.querySelectorAll('[data-ss-compare-entry]').forEach(button => { button.hidden = state.compare.length < 2; });
    document.querySelectorAll('[data-ss-count]').forEach(node => {
      node.textContent = String(state[node.dataset.ssCount]?.length || 0);
      if (node.classList.contains('ss-desk-trigger__count')) node.hidden = state.saved.length === 0;
    });
    document.querySelectorAll('[data-ss-model]').forEach(node => {
      let model; try { model = JSON.parse(node.dataset.ssModel); } catch (_) { return; }
      [['saved','save','saved'],['compare','compare','comparing']].forEach(([kind, action, activeLabel]) => {
        const button = node.querySelector('[data-ss-' + action + ']');
        if (!button) return;
        const active = has(kind, model.handle); button.setAttribute('aria-pressed', String(active));
        const label = button.querySelector('[data-ss-' + action + '-label]');
        if (label && label.textContent !== labels[active ? activeLabel : action]) label.textContent = labels[active ? activeLabel : action];
      });
    });
  };
  const mutate = (kind, model) => {
    if (!model) return;
    const exists = has(kind, model.handle);
    if (!exists && state[kind].length >= limits[kind]) { toast(labels[kind + '_limit']); return; }
    state[kind] = exists ? state[kind].filter(item => item.handle !== model.handle) : [compactRecord(model), ...state[kind]];
    write(); syncButtons(); toast(labels[(exists ? 'removed_' : 'added_') + (kind === 'saved' ? 'saved' : 'compare')]);
    if (dialog.open) renderDesk();
  };
  const getModel = async handle => {
    const cached = cache.get(handle);
    if (cached && Date.now() - cached.at < 30000) return cached.promise;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    const promise = (async () => {
      try {
        const url = new URL(productURL(handle), origin);
        url.searchParams.set('section_id','ss-model-fragment');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
        const response = await fetch(url, {signal: controller.signal, headers: {Accept: 'text/html'}, cache: 'no-store'});
        if (!response.ok) throw new Error(labels.load_error);
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const data = html.querySelector('[data-ss-live-model]');
        if (!data) throw new Error(labels.load_error);
        const model = safeModel(JSON.parse(data.dataset.ssModel));
        if (model.handle !== handle) throw new Error(labels.load_error);
        return model;
      } finally { clearTimeout(timeout); }
    })();
    cache.set(handle, {at: Date.now(), promise});
    promise.catch(() => cache.delete(handle));
    return promise;
  };
  const actions = model => {
    const row = element('div','ss-model-actions'); row.dataset.ssModel = JSON.stringify(model);
    [['save','saved'],['compare','compare']].forEach(([action,kind]) => {
      const button = element('button','',labels[action]); button.type = 'button'; button.dataset['ss' + action[0].toUpperCase() + action.slice(1)] = '';
      button.setAttribute('aria-pressed', String(has(kind,model.handle))); button.setAttribute('aria-label',labels[action] + ': ' + model.title);
      const span = element('span','',labels[action]); span.dataset['ss' + action[0].toUpperCase() + action.slice(1) + 'Label'] = '';
      button.replaceChildren(span); row.append(button);
    }); return row;
  };
  const card = (model, {kind = null, comparison = false, compact = false} = {}) => {
    const article = element('article','ss-model-tile');
    const imageLink = element('a','ss-model-tile__image'); imageLink.href = model.url;
    if (model.image) { const image = element('img'); image.src = model.image; image.alt = model.title; image.width = 600; image.height = 600; image.loading = 'lazy'; imageLink.append(image); }
    else imageLink.setAttribute('aria-label',model.title);
    article.append(imageLink);
    if (model.scale) article.append(element('span','ss-model-tile__scale',model.scale));
    if (kind) {
      const remove = element('button','ss-model-tile__remove'); remove.type = 'button'; remove.setAttribute('aria-label',labels.remove + ': ' + model.title);
      const icon = arrow(); icon.firstChild.setAttribute('d','m6 6 12 12M18 6 6 18'); remove.append(icon); remove.dataset.ssRemove = model.handle; remove.dataset.kind = kind; article.append(remove);
    }
    const body = element('div','ss-model-tile__body');
    if (model.vendor) body.append(element('p','ss-model-tile__vendor',model.vendor));
    const title = element('h3'); title.style.margin = '0';
    const link = element('a','ss-model-tile__title',model.title); link.href = model.url; title.append(link); body.append(title);
    body.append(element('p','ss-model-tile__price',(model.priceVaries ? labels.from + ' ' : '') + (model.priceText || labels.details)));
    if (comparison) {
      const facts = element('dl','ss-model-facts');
      [['brand',model.vendor],['scale',model.scale],['category',model.category],['sku',model.sku],['material',model.material],['dimensions',model.dimensions],['opening_parts',model.openings],['availability',model.available ? labels.available : labels.unavailable]].forEach(([name,value]) => {
        const row = element('div'); row.append(element('dt','',labels[name]),element('dd','',value || labels.not_provided)); facts.append(row);
      }); body.append(facts);
    }
    const controls = element('div','ss-model-tile__controls'); const view = element('a','',labels.view); view.href = model.url; controls.append(view); body.append(controls);
    if (!comparison) body.append(actions(model));
    if (!compact && model.available && model.simple && /^\d+$/.test(String(model.variantId))) {
      const form = element('form','ss-model-tile__form'); form.method = 'post'; form.action = root + 'cart/add'; form.dataset.ssMainAdd = '';
      [['id',model.variantId],['quantity',Math.max(1,Number(model.minimum)||1)]].forEach(([name,value]) => { const input = element('input'); input.type = 'hidden'; input.name = name; input.value = value; form.append(input); });
      const add = element('button','ss-os-primary',labels.add); add.type = 'submit'; add.dataset.ssCartControl = ''; form.append(add);
      const status = element('p','ss-model-tile__status'); status.dataset.status = ''; status.setAttribute('role','status'); form.append(status); body.append(form);
    }
    article.append(body); return article;
  };
  const errorCard = record => {
    const article = element('article','ss-model-tile'); const body = element('div','ss-model-tile__body');
    body.append(element('p','ss-model-tile__title',record.title),element('p','ss-model-tile__status',labels.load_error));
    const link = element('a','ss-os-text-button',labels.view); link.href = productURL(record.handle); body.append(link); article.append(body); return article;
  };
  const displayPlanner = results => {
    const section = element('section','ss-display-workbench');
    section.append(element('p','ss-os-kicker',labels.planner_eyebrow),element('h3','',labels.planner_title),element('p','ss-display-workbench__note',labels.planner_note));
    const known = results.filter(result => result.status === 'fulfilled' && Number.isFinite(result.value.lengthCm) && result.value.lengthCm > 0);
    if (known.length !== results.length) {
      section.append(element('p','ss-display-workbench__note',labels.planner_missing));
      return section;
    }
    const field = element('label','ss-display-workbench__field',labels.planner_width);
    const input = element('input'); input.type = 'number'; input.min = '1'; input.max = '1000'; input.step = '1'; input.value = '60'; field.append(input); section.append(field);
    const rail = element('div','ss-display-workbench__rail'); rail.setAttribute('aria-hidden','true');
    const output = element('p','ss-display-workbench__result'); output.setAttribute('role','status');
    const render = () => {
      const width = input.valueAsNumber;
      if (!input.checkValidity() || !Number.isFinite(width)) { output.textContent = labels.planner_invalid; rail.replaceChildren(); return; }
      const total = known.reduce((sum,result) => sum + result.value.lengthCm,0) + Math.max(0,known.length-1)*2;
      rail.replaceChildren(...known.map(result => { const piece = element('span','',result.value.scale || result.value.vendor); piece.style.flexBasis = (result.value.lengthCm / Math.max(width,total) * 100) + '%'; return piece; }));
      output.textContent = labels.planner_result.replace('[length]',total.toFixed(1)).replace('[remaining]',Math.max(0,width-total).toFixed(1)) + ' ' + (total > width ? labels.planner_over : labels.planner_under);
    };
    input.addEventListener('input',render); section.append(rail,output); render(); return section;
  };
  async function renderDesk() {
    const version = ++generation;
    const focused = document.activeElement;
    const restoreFocus = panel.contains(focused);
    const focusHandle = restoreFocus ? readModel(focused)?.handle || focused.dataset.ssRemove : null;
    const focusAction = focused?.hasAttribute('data-ss-save') ? 'save' : focused?.hasAttribute('data-ss-compare') ? 'compare' : null;
    panel.setAttribute('aria-busy','true');
    const records = [...state[mode]];
    host.querySelector('[data-ss-panel-note]').textContent = labels[mode + '_note'];
    host.querySelector('[data-ss-clear]').hidden = !records.length;
    if (!records.length) {
      const empty = element('div','ss-desk__empty'); empty.append(arrow(),element('p','',labels['empty_' + mode]));
      const browse = element('a','ss-os-primary',labels.view); browse.href = root + 'collections/all'; empty.append(browse); panel.replaceChildren(empty); panel.setAttribute('aria-busy','false'); return;
    }
    panel.replaceChildren(element('p','ss-os-kicker',labels.loading));
    if (restoreFocus) panel.focus({preventScroll:true});
    const results = await Promise.allSettled(records.map(record => getModel(record.handle)));
    if (version !== generation || !dialog.open) return;
    const grid = element('div',mode === 'compare' ? 'ss-compare-grid' : 'ss-desk__grid');
    grid.style.setProperty('--ss-compare-count',String(records.length));
    results.forEach((result,index) => grid.append(result.status === 'fulfilled' ? card(result.value,{kind:mode,comparison:mode==='compare'}) : errorCard(records[index])));
    panel.replaceChildren(grid);
    if (mode === 'compare') {
      const note = element('p','ss-comparison-note',labels.specification_note);
      panel.append(note);
      if (host.dataset.displayPlanner === 'true') panel.append(displayPlanner(results));
    }
    panel.setAttribute('aria-busy','false'); syncButtons();
    if (restoreFocus && document.activeElement === panel) {
      const row = focusHandle && [...grid.querySelectorAll('[data-ss-model]')].find(node => readModel(node)?.handle === focusHandle);
      const target = focusAction && row?.querySelector('[data-ss-' + focusAction + ']');
      (target || grid.querySelector('button,a'))?.focus({preventScroll:true});
    }
  }
  const selectTab = kind => {
    mode = Object.hasOwn(limits,kind) ? kind : 'saved';
    host.querySelectorAll('[data-ss-tab]').forEach(tab => { const selected = tab.dataset.ssTab === mode; tab.setAttribute('aria-selected',String(selected)); tab.tabIndex = selected ? 0 : -1; if (selected) panel.setAttribute('aria-labelledby',tab.id); });
    panel.scrollTop = 0; renderDesk();
  };
  const openDesk = (kind, trigger) => {
    previousFocus = trigger || document.activeElement;
    cache.clear();
    if (!dialog.open) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; document.documentElement.classList.add('ss-desk-open'); dialog.showModal(); }
    selectTab(kind); host.querySelector('[data-ss-tab="' + mode + '"]').focus({preventScroll:true});
  };
  let recentGeneration = 0, recentObserver;
  async function renderRecent() {
    const version = ++recentGeneration; recentObserver?.disconnect();
    const shelf = document.querySelector('[data-ss-recent-shelf]'); if (!shelf) return;
    const current = host.querySelector('[data-ss-current-model]'); const currentModel = current && readModel(current);
    const records = state.recent.filter(item => item.handle !== currentModel?.handle).slice(0,5);
    shelf.hidden = !records.length; if (!records.length) { shelf.querySelector('[data-ss-recent-grid]')?.replaceChildren(); return; }
    const grid = shelf.querySelector('[data-ss-recent-grid]');
    grid.replaceChildren(element('p','ss-os-kicker',labels.loading));
    const load = async () => {
      const results = await Promise.allSettled(records.map(item => getModel(item.handle)));
      if (version !== recentGeneration) return;
      grid.replaceChildren(...results.map((result,index) => result.status === 'fulfilled' ? card(result.value,{compact:true}) : errorCard(records[index]))); syncButtons();
    };
    if ('IntersectionObserver' in window) {
      recentObserver = new IntersectionObserver(entries => { if (entries.some(entry=>entry.isIntersecting)) { recentObserver.disconnect(); load(); } },{rootMargin:'250px'}); recentObserver.observe(shelf);
    } else load();
  }
  let stickyObserver, stickyMutation, stickyAbort;
  const connectSticky = () => {
    const sticky = document.querySelector('[data-ss-sticky]'); if (!sticky) return;
    const current = document.querySelector('[data-ss-current-model]'); if (!current) return;
    const form = document.querySelector('[data-ss-main-add]');
    const buy = form?.querySelector('[data-buy],button[type="submit"]');
    const hero = form?.closest('[data-product-url]'); if (!form || !buy || !hero) { sticky.hidden = true; return; }
    stickyObserver?.disconnect(); stickyMutation?.disconnect(); stickyAbort?.abort(); stickyAbort = new AbortController();
    const sync = () => {
      const button = sticky.querySelector('[data-ss-sticky-add]'); button.disabled = buy.disabled;
      if (button.textContent !== buy.textContent.trim()) button.textContent = buy.textContent.trim();
      const price = hero.querySelector('[data-price]'); if (price) sticky.querySelector('[data-ss-sticky-price]').textContent = price.textContent;
      const quantity = form.querySelector('[name="quantity"]'); sticky.querySelector('[data-ss-sticky-quantity]').textContent = labels.quantity + ': ' + (quantity?.value || 1);
    };
    sync(); form.addEventListener('input',sync,{signal:stickyAbort.signal}); form.addEventListener('change',sync,{signal:stickyAbort.signal});
    stickyMutation = new MutationObserver(sync); stickyMutation.observe(hero,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    let pending = false;
    const checkVisibility = () => {
      pending = false; const visible = buy.isConnected && buy.getBoundingClientRect().bottom < 0;
      sticky.hidden = !visible; document.documentElement.classList.toggle('ss-sticky-active',visible);
    };
    const scheduleVisibility = () => { if (!pending) { pending = true; requestAnimationFrame(checkVisibility); } };
    window.addEventListener('scroll',scheduleVisibility,{passive:true,signal:stickyAbort.signal});
    window.addEventListener('resize',scheduleVisibility,{passive:true,signal:stickyAbort.signal});
    stickyObserver = new IntersectionObserver(checkVisibility); stickyObserver.observe(buy); checkVisibility();
    sticky.querySelector('[data-ss-sticky-add]').onclick = () => { if (buy.isConnected && !buy.disabled) form.requestSubmit(buy); };
  };
  document.addEventListener('click',event => {
    const button = event.target.closest('button,[data-ss-open]'); if (!button) return;
    if (button.hasAttribute('data-ss-save')) mutate('saved',readModel(button));
    else if (button.hasAttribute('data-ss-compare')) mutate('compare',readModel(button));
    else if (button.hasAttribute('data-ss-open')) openDesk(button.dataset.ssOpen,button);
    else if (button.hasAttribute('data-ss-tab')) selectTab(button.dataset.ssTab);
    else if (button.hasAttribute('data-ss-close')) dialog.close();
    else if (button.hasAttribute('data-ss-remove') && Object.hasOwn(limits,button.dataset.kind)) {
      const kind = button.dataset.kind; state[kind] = state[kind].filter(item => item.handle !== button.dataset.ssRemove); write(); syncButtons(); renderDesk();
    } else if (button.hasAttribute('data-ss-clear')) { state[mode] = []; write(); syncButtons(); renderDesk(); if (mode === 'recent') renderRecent(); host.querySelector('[data-ss-tab="' + mode + '"]').focus(); toast(labels.cleared); }
  });
  dialog.addEventListener('click',event => { if (event.target !== dialog) return; const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); });
  dialog.addEventListener('close',() => { ++generation; deskAddPending = false; document.body.style.overflow = previousOverflow || ''; document.documentElement.classList.remove('ss-desk-open'); const drawer = document.querySelector('cart-drawer.active'); const target = drawer?.querySelector('.drawer__close,button') || (previousFocus?.isConnected ? previousFocus : null); target?.focus({preventScroll:true}); });
  host.querySelector('[role="tablist"]').addEventListener('keydown',event => {
    if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault(); const tabs = [...host.querySelectorAll('[data-ss-tab]')]; const index = tabs.indexOf(document.activeElement);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[next].focus(); selectTab(tabs[next].dataset.ssTab);
  });
  const storageNote = host.querySelector('[data-ss-storage-note]'); storageNote.dataset.defaultText = storageNote.textContent;
  const current = host.querySelector('[data-ss-current-model]'); const currentModel = current && readModel(current);
  if (currentModel) { state.recent = [compactRecord(currentModel), ...state.recent.filter(item => item.handle !== currentModel.handle)].slice(0,limits.recent); write(); }
  else if (!persistent) storageNote.textContent = labels.session_note;
  window.addEventListener('storage',event => { if (event.key !== key) return; try { state = normalise(JSON.parse(event.newValue || '{}')); syncButtons(); renderRecent(); if (dialog.open) renderDesk(); } catch (_) {} });
  let syncTimer;
  const changes = new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-ss-model]') || node.querySelector?.('[data-ss-model]'))))) return;
    clearTimeout(syncTimer); syncTimer = setTimeout(syncButtons,50);
  }); changes.observe(document.querySelector('main'),{subtree:true,childList:true});
  document.addEventListener('ss:product-rendered',connectSticky);
  document.addEventListener('shopify:section:load',() => { syncButtons(); connectSticky(); });
  document.addEventListener('submit',event => { if (dialog.open && dialog.contains(event.target) && event.target.matches('form[data-ss-main-add]')) deskAddPending = true; });
  document.addEventListener('ss:cart-updated',() => { cache.clear(); if (dialog.open && deskAddPending) { deskAddPending = false; dialog.close(); } else if (dialog.open) renderDesk(); });
  document.querySelectorAll('[data-ss-finder]').forEach(finder => {
    const form = finder.querySelector('form'), select = finder.querySelector('[data-ss-finder-collection]');
    const first = select.options[0].cloneNode(true);
    finder.addEventListener('click',event => {
      const button = event.target.closest('[data-ss-finder-mode]'); if (!button) return;
      finder.querySelectorAll('[data-ss-finder-mode]').forEach(node => node.setAttribute('aria-pressed',String(node === button)));
      const options = [...finder.querySelectorAll('[data-ss-finder-options] [data-mode]')].filter(node=>node.dataset.mode===button.dataset.ssFinderMode);
      select.replaceChildren(first.cloneNode(true),...options.map(node=> { const option = element('option','',node.textContent); option.value = node.dataset.url; return option; }));
    });
    form.addEventListener('submit',event => {
      event.preventDefault(); const url = new URL(select.value || finder.dataset.catalog,origin);
      if (url.origin !== origin || !url.pathname.includes('/collections/')) return;
      const budget = finder.querySelector('[data-ss-finder-budget]').value;
      if (budget) url.searchParams.set('filter.v.price.lte',budget);
      else url.searchParams.delete('filter.v.price.lte');
      const preview = new URL(location.href).searchParams.get('preview_theme_id'); if (preview) url.searchParams.set('preview_theme_id',preview);
      url.searchParams.delete('page'); location.assign(url.pathname + url.search);
    });
  });
  syncButtons(); connectSticky(); renderRecent(); document.documentElement.classList.add('ss-os-ready');
  window.ScaleShowroomCollector = {open:openDesk,refresh:syncButtons};
  };
  if (document.readyState === 'loading') {
    const ready = () => {
      if (document.readyState === 'loading') return;
      document.removeEventListener('readystatechange', ready);
      start();
    };
    document.addEventListener('readystatechange', ready);
  } else start();
})();
